<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("weekwiseContract", 2) }}
      </div>
      <router-link class="btn-blue" to="weekwise-contract">
        {{ $tc("weekwiseContract", 2) }} {{ $tc("list", 2) }}
      </router-link>
    </div>

    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- Contract Name -->
          <div class="col-lg-6 col-xl-4 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  id="weekwise_name"
                  v-model="contract_weekwise_name"
                  v-b-tooltip.hover
                  v-validate="'required'"
                  :title="$t('contract_name_tooltip')"
                  name="weekwise_name"
                  placeholder="."
                  type="text"
                />
                <label>{{ $t("weekwise") }} {{ $tc("contract", 2) }} {{ $tc("name", 2) }}</label>
              </div>
            </div>
            <p class="error_message" style="margin-top: 2px">
              <span v-if="submitted && errors.has('weekwise_name')">{{ errors.first("weekwise_name") }}</span>
            </p>
          </div>

          <!-- Active Status -->
          <div class="col-lg-6 col-xl-8 align-self-center mb-0">
            <div class="d-flex align-items-center justify-content-end">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="mb-0 ml-2">
                <b-form-checkbox
                  v-model="contracts_by_weekwise_is_active"
                  checked
                  class="j-checkbox mb-0"
                  type="checkbox"
                />
              </label>
            </div>
            <p class="error_message" style="margin-top: 2px"><span></span></p>
          </div>

          <!-- Weekwise Contract Details -->
          <div class="col-lg-12 mb-2">
            <h5 class="mb-0 heading">{{ $t("contract") }} {{ $tc("details", 2) }}</h5>
          </div>

          <!-- Loop through Weekwise Contracts -->
          <div
            v-for="(WeekwiseContract, WeekwiseContractKey) in WeekwiseContracts"
            :key="WeekwiseContractKey"
            class="col-12 mb-1 mt-1"
          >
            <div class="pt-3 pl-3 pr-3 pb-1 border rounded-10 back">
              <div class="row">
                <div class="col-lg-10 col-xl-11">
                  <div class="row">
                    <!-- Select Week -->
                    <div class="col-lg-6 col-xl-4 mb-0" style="height: 55px">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <multiselect
                            id="select_week"
                            :value="WeekwiseContract.contract_week"
                            v-b-tooltip.hover
                            :multiple="false"
                            :options="weekArray.filter(w => w.value == WeekwiseContractKey || w.value == -1)"
                            :placeholder="selectedWeek"
                            :title="$t('select_week_tooltip')"
                            data-vv-name="Week"
                            data-vv-rules="required"
                            data-vv-value-path="value"
                            label="name"
                            name="select_week"
                            track-by="value"
                            @select="onSelectWeek($event, WeekwiseContractKey)"
                          ></multiselect>
                        </div>
                      </div>
                      <p class="error_message" style="margin-top: 2px">
                        <span v-if="submitted && !WeekwiseContract.contract_week">
                          {{ selectedWeek }}
                        </span>
                      </p>
                    </div>

                    <!-- Select Contract -->
                    <div class="col-lg-6 col-xl-5 mb-0" style="height: 55px">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <multiselect
                            id="select_contract"
                            :value="WeekwiseContract.contract_id"
                            v-b-tooltip.hover
                            :multiple="false"
                            :options="ms_contracts"
                            :placeholder="selectedContract"
                            :title="$t('select_contract_tooltip')"
                            label="contract_name"
                            name="select_contract"
                            track-by="contract_id"
                            @select="onSelectContract($event, WeekwiseContractKey)"
                          ></multiselect>
                        </div>
                      </div>
                      <p class="error_message" style="margin-top: 2px">
                        <span v-if="submitted && !WeekwiseContract.contract_id">
                          {{ selectedContract }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Buttons for Adding/Removing Contracts -->
                <div class="col-lg-2 col-xl-1 border-left d-flex justify-content-center align-items-center">
                  <button
                    v-if="WeekwiseContractKey === 0"
                    class="btn-transparent"
                    @click.stop.prevent="addWeekWiseContract"
                  >
                    <img height="30" src="@/assets/img/icons/plus.svg" width="30" />
                  </button>
                  <button
                    v-if="WeekwiseContractKey !== 0 && WeekwiseContractKey === WeekwiseContracts.length - 1"
                    class="btn-transparent"
                    @click.stop.prevent="removeWeekWiseContract(WeekwiseContractKey)"
                  >
                    <img height="30" src="@/assets/img/icons/minus.svg" width="30" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="col-12 text-center pt-3">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="onFinalSubmit"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";

export default {
  data() {
    return {
      submitted: false,
      btenable: false,
      contract_weekwise_name: "",
      contracts_by_weekwise_is_active: true,
      ms_contracts: [],
      weekArray: [
        { name: "Week 1", value: 0 },
        { name: "Week 2", value: 1 },
        { name: "Week 3", value: 2 },
        { name: "Week 4", value: 3 },
        { name: "Week 5", value: 4 },
        { name: "Week 6", value: 5 },
        { name: "Thereafter", value: -1 }
      ],
      selectedContract: "Contract Type.",
      selectedWeek: "Week.",
      WeekwiseContracts: [
        { contract_week: "", contract_id: "" }
      ]
    };
  },
  mounted() {
    this.getActiveContracts();
  },
  methods: {
    getActiveContracts() {
      let payload = { tableName: "ms_contracts", contract_is_active: "Y" };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_contracts = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    addWeekWiseContract() {
      console.log("Before adding:", this.WeekwiseContracts);
      if (this.WeekwiseContracts.findIndex(w => w.contract_week === -1) !== -1) {
        this.$toasted.show("You have already added 'Thereafter'. Cannot add any more weeks.");
        return;
      } else {
        this.WeekwiseContracts.push({ contract_week: "", contract_id: "" });
      }
      console.log("After adding:", this.WeekwiseContracts);
    },
    removeWeekWiseContract(index) {
      console.log("Removing contract at index:", index);
      this.WeekwiseContracts.splice(index, 1);
    },
    onSelectWeek(event, index) {
      console.log("week value=>",event)
      console.log(`Selected Week ${event.name} at index ${index}`);
      this.WeekwiseContracts[index].contract_week = event;

      if (event.value === -1 && this.WeekwiseContracts.length - 1 !== index) {
        this.WeekwiseContracts = this.WeekwiseContracts.slice(0, index + 1);
      }
    },
    onSelectContract(event, index) {
      console.log("contact event=>",event)
      console.log(`Selected Contract ${event.contract_name} at index ${index}`);
      this.WeekwiseContracts[index].contract_id = event;
    },
    ContractDetailsValidation() {
      let count = 0;
      this.WeekwiseContracts.map(x => {
        if (!x.contract_week || !x.contract_id) count++;
      });

      const thereAfterIndex = this.WeekwiseContracts.findIndex(w => w.contract_week.value === -1);
      if (thereAfterIndex === -1) {
        this.$toasted.show("Please add a 'ThereAfter' contract.");
      }

      return count > 0 || thereAfterIndex === -1;
    },
    onFinalSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (this.ContractDetailsValidation()) {
          return;
        }
        if (valid) {
          this.btenable = true;
          let  updateArray=this.WeekwiseContracts.map((row)=>{
            row
            return {
              contract_id:row.contract_id,
              contract_week:row.contract_week
            }
          })
          console.log("updateArray=>",updateArray)
          let payload = {
            contract_weekwise_name: this.contract_weekwise_name,
            contracts_by_weekwise_is_active: this.contracts_by_weekwise_is_active?"Y":"N",
            WeekwiseContracts: updateArray
          };
          DistributorService.AddMasterContractByWeekWise(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.$router.push({ path: "weekwise-contract" });
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message || data.error.sqlMessage);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style>
.back {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/addWeekwiseContract.vue